import { Requirements_Get } from 'data/endpoints';
import IDataService from 'data/IDataService';
import IRepository from 'data/IRepository';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import React, { useEffect, useState } from 'react';
import RequirementFull from '../dtos/RequirementFullDTO';
import RequirementInfoCard from '../components/RequirementInfoCard';
import RequirementDescriptorsCard from '../components/RequirementDescriptorsCard';
import RequirementReactionsSection from './RequirementReactionsSection';
import RequirementDocumentsSection from './RequirementDocumentsSection';
import RequirementAlertsSection from './RequirementAlertsSection';
import { isEmpty } from 'features/shared/helpers/objects';

interface Props {
  requirementId: string;
}

const RequirementDetailSection = ({ requirementId }: Props) => {
  // DI
  const dataService = useInjection<IDataService>(IocTypes.DataService);
  const requirementRepo = useInjection<IRepository<RequirementFull>>(IocTypes.Repository);

  // state
  const [requirement, setRequirement] = useState<RequirementFull>({});
  const [addedDocumentsCount, setAddedDocumentsCount] = useState(0);

  // side effects / fetch data
  useEffect(() => {
    dataService.fetchAndSetOne<RequirementFull>(requirementRepo, setRequirement, Requirements_Get, getRouteParams("requirementId", requirementId));
  }, [requirementId])

  // render
  if (!isEmpty(requirement)) {
    return (
      <>
        <RequirementAlertsSection requirement={requirement} setRequirement={setRequirement} />
        <RequirementInfoCard 
          requirement={requirement} 
          enableDescription={!!requirement.descriptionShort}
        />
        {requirement.requirementDescriptor &&
          <RequirementDescriptorsCard descriptors={requirement.requirementDescriptor} />
        }
        <div className="row no-gutters mx-n2">
          <div className="col-xl-6 px-2">
            <RequirementReactionsSection 
              requirementId={requirementId} 
              requirementType={requirement.requirementType!} 
              addedDocumentsCount={addedDocumentsCount} 
              setAddedDocumentsCount={setAddedDocumentsCount}
            />
          </div>
          <div className="col-xl-6 px-2">
            <RequirementDocumentsSection 
              requirementId={requirementId} 
              requirementType={requirement.requirementType!} 
              addedDocumentsCount={addedDocumentsCount} 
              setAddedDocumentsCount={setAddedDocumentsCount}
            />
          </div>
        </div>
      </>
    )
  } else {
    return null;
  }
}

export default RequirementDetailSection;
